<template>
  <div class="supplier-general-main">
    <Input placeholder="Name" :inputValue.sync="data.name" :isDisabled="viewMode" :isRequired="true" ref="Spp_Name" />
    <div class="flex-row">
      <Input placeholder="Short Name" style="padding-right: 5px" :inputValue.sync="data.shortName" :isDisabled="viewMode" :isRequired="true" ref="Spp_sName" />
      <InputQuery style="padding-left: 5px" placeholder="Creditor" :items="data.creditor" :selectedObject.sync="data.selectedCreditor"
        itemKey="Creditor Code" descKey="Creditor Name" :isDisabled="viewMode" />
    </div>
    <AddressForm :data="data" :viewMode="viewMode" />
    <div class="flex-row">
      <Input placeholder="Phone No." style="padding-right: 5px" :inputValue.sync="data.phone" :isDisabled="viewMode" />
      <Input placeholder="Fax No." style="padding-left: 5px" :inputValue.sync="data.fax" :isDisabled="viewMode" />
    </div>
    <Input placeholder="E-Mail" :inputValue.sync="data.email" :isDisabled="viewMode" />
    <Dropdown placeholder="Category" :selectedObject.sync="data.selectedCategory" :items="data.categoryItems"
      :search.sync="data.categorySearch" :isDisabled="viewMode" />
  </div>
</template>

<script>
/* eslint-disable */
import Input from '@/components/Input.vue';
import Dropdown from '@/components/Dropdown.vue';
import AddressForm from '@/components/AddressForm.vue';
import InputQuery from '@/components/InputQuery.vue';

export default {
  components: {
    Input, Dropdown, AddressForm, InputQuery
  },
  props: {
    data: { type: Object, default: function() { return {} } },
    viewMode: { type: Boolean, default: false },
  },
  methods: {
  },
  mounted() {
    this.$bus.$on('supplierGeneralFocusElement', (element) => {
      this.$refs[element].setFocus();
    });
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.flex-row {
  display: flex;
}
</style>